<template>
  <div class="row m-0 ticket align-items-center-">
    <div class="col-sm-2 p-0 d-none d-lg-inline-block my-auto">
      <img
        src="/images/ticket-pervs.png"
        alt="fpf"
        class="img-fluid ticket__image"
      >
    </div>
    <div class="col-md-7 col-lg-6 py-2 pr-0">
      <p class="mb-0 ticket__name">
        <b>
          {{ participant.name }} {{ participant.lastName }}
        </b>
      </p>
      <span class="font-xs text-uppercase">
        {{ dateFirst }}
      </span>
      <p class="mt-1 mb-0 ticket__seat">
        {{ stadiumName }} | {{ participant.ticketTypeName }}
        <span v-if="validateSeat && participant.seat">
          | Asiento: {{ participant.seat }}
        </span>
      </p>
    </div>
    <div class="col-md-5 col-lg-4 p-0 d-flex justify-content-between align-items-center">
      <div class="col-6 col-md-8 p-0 text-center">
        <button
          v-if="participant.code && validateSeat && participant.change"
          type="button"
          @click="onViewTicket()"
          class="btn btn-secondary ticket__button my-0 my-md-1"
        >
          VER ENTRADA
        </button>
        <button
          v-if="participant.change === 0 && validateSeat"
          type="button"
          @click="editUser()"
          class="btn btn-primary ticket__button my-0 my-md-1"
        >
          EDITAR Y VER MI ENTRADA
        </button>
        <p class="my-auto font-xs" v-if="!validateSeat">
          Estamos asignando tu asiento. Se paciente
        </p>
      </div>
      <div class="col-6 col-md-4 p-0 text-center ticket__change-date bg-light h-100"
        @click="editUser()">
        <img
          :src="imgStatus"
          alt="img"
          class="img-fluid ticket__change-image"
        >
        <span class="ticket__change-title">
          {{ validateUser ? 'Datos completos' : 'Datos incompletos' }}
          {{ (!participant.change && validateSeat) ? '(Editar)' : '' }}
        </span>
      </div>
    </div>

    <b-modal v-model="modalInfo" hide-header hide-footer centered>
      <div class="d-block p-2">
        <h4>Actualizar y emitir entrada</h4>
        <hr>
        <h5>Puedes actualizar tus datos una sola vez.</h5>
        <h5>Recuerda que puedes editar y emitir tu entrada hasta el mismo día del evento.</h5>
        <p>Si estás seguro dale clic en "Editar datos", caso contrario clic en la X</p>
      </div>
      <a href="#" @click.prevent="modalInfo = false"
        class="btn-close-modal">
        <i class="fa fa-times text-dark"></i>
      </a>
      <button type="button" name="button"  @click="onChangeInfo()"
        class="btn btn-sm py-2 px-5 btn-primary btn-submit-modal">
        <b>EDITAR DATOS</b>
      </button>
    </b-modal>

    <b-modal v-model="modalEdit" hide-header hide-footer size="md" centered no-close-on-backdrop>
      <div class="d-block p-2">
        <h4 v-if="participant.change === 0">Editar y emitir entrada</h4>
        <h4 v-else>Editar datos</h4>
        <hr>
        <form @submit.prevent="submitChangeParticipant()" action="#">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label class="d-block">
                  <span>Nombres</span>
                  <input
                    v-model="formEditParticipant.name"
                    type="text"
                    maxlength="80"
                    class="form-control"
                    required autocomplete="off">
                </label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label class="d-block">
                  <span>Apellidos</span>
                  <input
                    v-model="formEditParticipant.lastName"
                    type="text"
                    maxlength="80"
                    class="form-control"
                    required autocomplete="off">
                </label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label class="d-block">
                  <span>Tipo documento</span>
                  <select v-model="formEditParticipant.documentType" class="form-control" required>
                    <option value="DNI">DNI</option>
                    <option value="CE">CE</option>
                    <option value="PASS">PASS</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label class="d-block">
                  <span>N° Documento</span>
                  <input
                    v-if="formEditParticipant.documentType === 'DNI'"
                    v-model="formEditParticipant.document"
                    type="text"
                    maxlength="8"
                    class="form-control"
                    v-on:keyup="acceptNum($event, 'document')"
                    required autocomplete="off">
                  <input
                    v-else
                    v-model="formEditParticipant.document"
                    type="text"
                    maxlength="15"
                    class="form-control"
                    v-on:keyup="acceptNum($event, 'document')"
                    required autocomplete="off">
                </label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label class="d-block">
                  <span>Email (Opcional)</span>
                  <input
                    v-model="formEditParticipant.email"
                    type="email"
                    maxlength="120"
                    class="form-control"
                    autocomplete="off">
                </label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label class="d-block">
                  <span>N° Celular (Opcional)</span>
                  <input
                    v-model="formEditParticipant.phone"
                    type="text"
                    maxlength="15"
                    class="form-control"
                    v-on:keyup="acceptNum($event, 'phone')"
                    autocomplete="off">
                </label>
              </div>
            </div>
            <div class="col-12">
              <div class="custom-control custom-checkbox">
                <input type="checkbox"
                  class="custom-control-input"
                  :id="`checkbox-child-${participant.codeQRId}`"
                  v-model="formEditParticipant.isChild"
                  :checked="formEditParticipant.isChild"
                  :value="formEditParticipant.isChild">
                <label class="custom-control-label"
                  :for="`checkbox-child-${participant.codeQRId}`">
                  ¿El asistente es menor de edad?
                </label>
              </div>
            </div>
            <div class="col-12 text-danger text-center font-xs">
              {{ error }}
            </div>
          </div>
          <div v-if="participant.change === 0" class="mt-3">
            *Una vez emitida, te enviaremos una copia de esta a tu email.
          </div>
          <button
            type="submit"
            :disabled="loading"
            class="btn btn-action py-2 px-5 rounded-0 btn-submit-modal"
          >
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            <b>CONFIRMAR Y VER ENTRADA</b>
          </button>
        </form>
      </div>
      <a href="#" @click.prevent="modalEdit = false" class="btn-close-modal-intern">
        <i class="fa fa-times text-dark"></i>
      </a>
    </b-modal>

  </div>
</template>
<script>
import api from '../api';

const useri = {
  name: '',
  lastName: '',
  documentType: 'DNI',
  document: '',
  email: '',
  phone: '',
  isChild: false,
};

export default {
  props: {
    participant: Object,
    email: String,
    index: Number,
  },
  data() {
    return {
      formEditParticipant: { ...useri },
      participantClon: {},
      error: '',
      codeQRId: '',
      modalEdit: false,
      modalInfo: false,
      modalAlert: false,
      loading: false,
    };
  },
  computed: {
    validateUser() {
      const {
        name,
        lastName,
        documentType,
        document,
      } = this.participant;
      return name && lastName && documentType && document;
    },
    imgStatus() {
      if (this.validateUser) return '/images/status-user/valid.svg';
      return '/images/status-user/warning.svg';
    },
    validateSeat() {
      const { seat } = this.participant;
      if (!seat) return true;
      const result = seat.split('_').find(val => val === 'SEAT');
      return !result;
    },
  },
  methods: {
    editUser() {
      if (this.participant.change) return;
      if (!this.validateSeat) return;
      this.participantClon = { ...this.participant };
      this.formEditParticipant = { ...useri, ...this.participant };
      if (this.participant.change === 0) {
        this.modalInfo = true;
      } else {
        this.modalEdit = true;
      }
    },
    onViewTicket() {
      const { participant, index } = this;
      this.$emit('onViewTicketList', { participant, index });
    },
    onChangeInfo() {
      this.error = '';
      this.modalInfo = false;
      this.modalEdit = true;
    },
    async submitChangeParticipant() {
      // let validate = true;
      // if (this.formEditParticipant.documentType === 'DNI') {
      //   validate = await this.validateUserApi(this.formEditParticipant);
      // }
      // if (!validate) return;

      this.loading = true;
      this.error = '';

      const data = {
        ticketCodeId: this.participant.codeQRId,
        name: this.formEditParticipant.name,
        lastName: this.formEditParticipant.lastName,
        documentType: this.formEditParticipant.documentType,
        document: this.formEditParticipant.document,
        email: this.formEditParticipant.email,
        phone: this.formEditParticipant.phone,
        isChild: this.formEditParticipant.isChild,
      };
      const url = `${this.apiUrl}/code-exchange/update-participant`;
      api.axios.put(url, data).then((res) => {
        const { message, success } = res.data;
        this.loading = false;
        if (!success) {
          // this.formEditParticipant = { ...this.participantClon };
          this.error = message;
          return;
        }
        this.emitUpdate();
        this.modalEdit = false;
      }).catch(() => {
        this.error = 'Error al editar participante.';
        this.loading = false;
        this.formEditParticipant = { ...this.participantClon };
      });
    },
    emitUpdate() {
      const payload = {
        participant: this.participant,
        email: this.email,
      };
      this.$emit('update', payload);
    },
    async validateUserApi(user) {
      this.loading = true;
      try {
        const url = `${api.nodeUrl}/validate-documents`;
        user.percent = 45;
        const { data: res } = await api.axios.post(url, [user]);
        this.loading = false;
        if (!res.data[0].status) {
          this.error = res.data[0].message;
          return false;
        }
        return true;
      } catch (err) {
        this.error = 'Error, inténtalo en un momento.';
        this.loading = false;
        setTimeout(() => {
          this.error = '';
        }, 9000);
        return false;
      }
    },
    acceptNum(event, value) {
      const key = event.keyCode;
      if (!(key <= 13 || (key >= 48 && key <= 57) || key === 46)) {
        if (value === 'document') {
          this.formEditParticipant.document = this.formEditParticipant.document.replace(/[^0-9]+/, '');
        } else {
          this.formEditParticipant.phone = this.formEditParticipant.phone.replace(/[^0-9]+/, '');
        }
      }
    },
  },
};
</script>
